import { render, staticRenderFns } from "./TradeRequestDirectManageResponse.vue?vue&type=template&id=4b307704"
import script from "./TradeRequestDirectManageResponse.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirectManageResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports